import { Toaster } from "@/components/ui/toaster.tsx";
import { AuthProvider } from "@/context/auth/AuthProvider";
import { QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import { TooltipProvider } from "./components/ui/tooltip";
import { LastTimeNewOrdersCheckedProvider } from "./context/OrderContext";
import { AppRouter } from "./pages/routes";
import "./i18n";
import { queryClient } from "@/lib/queryClient";

// i18next est déjà initialisé par l'import de `./i18n` (effet de bord au
// chargement du module). Un second `i18n.init()` ici relançait une
// initialisation en double, source de re-render/remount parasites après le
// chargement (tardif) des traductions.

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LastTimeNewOrdersCheckedProvider>
          <TooltipProvider>
            <AppRouter />
            <Toaster />
          </TooltipProvider>
        </LastTimeNewOrdersCheckedProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
